<!--@if (!isLoading()) {
  <app-scheme-card [scheme]="scheme()!"></app-scheme-card>
}-->
@if (hasActiveFilters()) {
  <section>
    @for (key of facetKeys; track key) {
      @if (activeFilters()[key].length) {
        <mat-chip-set>
          @for (node of activeFilters()[key]; track trackSelectedNode($index, node)) {
            <mat-chip>{{selectedNodeLabel(node)}}</mat-chip>
          }
        </mat-chip-set>
      }
    }
  </section>
}
<p>{{ totalSchemesCount() }} Schemen gefunden</p>
<mat-grid-list cols="4" gutterSize="16px">
  @for (scheme of schemes(); track scheme.schematicId) {
    <mat-grid-tile>
      <app-scheme-card [scheme]="scheme"></app-scheme-card>
    </mat-grid-tile>
  }
</mat-grid-list>
<div #sentinel class="scroll-sentinel"></div>
